import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Receipt } from "../../domain/models/receipt-model";
import { StoreItem } from "../../domain/models/storage-item";
import {
  CheckReceipt,
  CheckReceiptResult,
} from "../../domain/usecases/check-receipt";
import { InvalidFieldError } from "../../validation/errors";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbCheckReceipt implements CheckReceipt {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async check(
    receiptId: number,
    count: StoreItem[]
  ): Promise<CheckReceiptResult> {
    const response = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: { receiptId, count },
    });

    switch (response.statusCode) {
      case HttpStatusCode.ok:
        return response.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      case HttpStatusCode.badRequest:
        throw new InvalidFieldError();
      default:
        throw new UnexpectedError();
    }
  }
}
